import React, { useState } from "react";

function DeckRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "What areas do you serve?",
      content: `
       We proudly provide professional deck removal services in:

Campbell | Los Altos | Fremont | Palo Alto | Saratoga | East Palo Alto | Cupertino | Los Gatos | Mountain View | San Jose | Milpitas | Newark | Santa Clara | Sunnyvale
      `,
    },
    {
      title: "Do you offer eco-friendly disposal options?",
      content: `
       Yes! We prioritize minimizing environmental impact by recycling deck removal materials, including wood deck boards and concrete footings.
      `,
    },
    {
      title: "What safety equipment do you use?",
      content: `
         Our team adheres to strict occupational health standards, using eye protection, knee pads, closed-toe shoes, and gloves to ensure safety during demolition work.
        `,
    },
    {
      title: "Can I do DIY Deck Removal?",
      content: `
         While DIY deck removal is possible, it requires essential tools, knowledge of the most effective methods to dismantle a deck, and awareness of potential safety hazards. Hiring a demolition contractor can save time and effort.
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default DeckRemovalFAQs;
